/* ATLAS (Pagespeed R2): lazy country list for Horizon's localization selector.
   The country rows are rendered once per page inside the inert
   <template id="atlas-country-list-src"> (snippets/atlas-country-list-template.liquid,
   rendered by layout/theme.liquid before </body>). On the first user intent inside a
   <dropdown-localization-component> (desktop) or <drawer-localization-component>
   (mobile drawer) the template is cloned into that copy's <ul data-atlas-lazy>.
   Horizon's assets/localization.js is untouched: search, keyboard navigation and
   selectCountry -> form.submit() work on the cloned rows because Horizon delegates
   on:click at document level and refs are refreshed via Component.updatedCallback(). */
(function () {
  'use strict';

  if (window.__atlasCountryListInit) return;
  window.__atlasCountryListInit = true;

  var SRC_ID = 'atlas-country-list-src';
  var HOSTS = 'dropdown-localization-component, drawer-localization-component';
  var MENU_DETAILS_ID = 'Details-menu-drawer-container';

  function fill(host) {
    var list = host.querySelector('ul[data-atlas-lazy]');
    if (!list) return;
    if (list.querySelector('li.localization-form__list-item')) return; /* already stamped */

    var src = document.getElementById(SRC_ID);
    if (!(src instanceof HTMLTemplateElement)) return;

    list.appendChild(src.content.cloneNode(true));

    var form = host.querySelector('localization-form-component');
    if (form && typeof form.updatedCallback === 'function') {
      /* refs.countryListItems only exists once at least one row carries the ref, and the
         component's MutationObserver is attached in requestIdleCallback; updatedCallback()
         (assets/component.js) rebuilds refs synchronously. Before upgrade there is nothing
         to refresh: connectedCallback snapshots the already-filled list. */
      form.updatedCallback();
    }
  }

  function fillAll() {
    var hosts = document.querySelectorAll(HOSTS);
    for (var i = 0; i < hosts.length; i++) fill(hosts[i]);
  }

  function onIntent(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var host = target.closest(HOSTS);
    if (host) fill(host);
  }

  function idle(callback) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(callback, { timeout: 500 });
    } else {
      window.setTimeout(callback, 0);
    }
  }

  /* Opening the hamburger menu pre-stamps the drawer copy during idle time, so the
     later tap on "Region and language" does not pay the clone cost. No network. */
  function onToggle(event) {
    var target = event.target;
    if (!(target instanceof HTMLDetailsElement) || !target.open || target.id !== MENU_DETAILS_ID) return;
    idle(function () {
      var host = target.querySelector('drawer-localization-component');
      if (host) fill(host);
    });
  }

  /* pointerdown/keydown fire before the click that runs Horizon's toggleSelector, so the
     panel is already full when showPanel measures --width after its open animation.
     click covers assistive tech that dispatches a bare click; focusin covers keyboard
     focus landing on the trigger button or the search input; input covers autofill or
     programmatic input into the search field (Horizon's filterCountries reads the rows
     unguarded). Capture phase, one closest() per event. */
  var types = ['pointerdown', 'keydown', 'focusin', 'input', 'click'];
  for (var i = 0; i < types.length; i++) {
    document.addEventListener(types[i], onIntent, true);
  }
  document.addEventListener('toggle', onToggle, true);

  /* Theme editor only: theme-editor.js reopens a dropdown programmatically via showPanel()
     after an editor refresh (no user event inside the host), so both copies are pre-stamped
     in idle time there. Zero effect on the storefront. */
  if (window.Shopify && window.Shopify.designMode) {
    idle(fillAll);
  }
})();